<template>
  <div class="cplan-card-outer">
    <div class="cplan-completed-unit-card">
      <div class="cplan-completed-unit-card__code">{{item.relationship.code}}</div>
      <div class="cplan-completed-unit-card__title">
        <button type="button" class="btn-link-bold" v-on:click="clickUnitTitle">{{item.relationship.name}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SlideOutUnitDetailsView from '../select-units/slide-out-tree-view/SlideOutUnitDetailsView.vue'

export default {
  props: {
    unitCode: { type: String, required: true }
  },
  data() {
    return {
      slideOutComponent: SlideOutUnitDetailsView
    }
  },
  computed: {
    ...mapGetters({
      selectedItems: 'units/getSelectedCurriculumItems'
    }),
    item() {
      return this.selectedItems.find((u) => u.code === this.unitCode)
    },
    labelClass() {
      return `unit-${this.item.firstLevelTitle.toLowerCase().replace(/\s/gi, '-')}`
    }
  },
  methods: {
    ...mapMutations('global', {
      openSlideOut: 'openSlideOut'
    }),
    clickUnitTitle() {
      this.item.canComplete = false
      this.openSlideOut({ component: this.slideOutComponent, componentProperties: this.item })
    }
  }
}
</script>

